




















import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { QueryPayOrderByNo } from '@/api'
import { Message } from 'element-ui'
import { ElForm } from 'element-ui/types/form'
import Rules from '@/utils/rules'
import { getByParentId } from '@/store/classifyStore'
import { VImageUpload } from '@/components/upload'

@Component({
  components: {
    VImageUpload,
  },
})
export default class PayDescDialog extends Vue {
  private show = false
  private data: any = {}

  @Emit('close')
  private close() {
    this.show = false
    this.data = {}
  }
  public open(payOrderNo: string) {
    this.show = true
    this.data.payOrderNo = payOrderNo
    this.loadData()
  }

  private async loadData() {
    const result = await QueryPayOrderByNo({ payOrderNo: this.data.payOrderNo })
    this.data = result
  }

  public async save() {
    this.close()
  }
}
